module.exports = __webpack_public_path__ + "img/review-img-1.8031da11.png";